import { Component, model, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Button, Input } from "@malirang/front-share";

@Component({
    selector: "app-product-category-form",
    templateUrl: "./product-category-form.component.html",
    styleUrls: ["./product-category-form.component.css"],
    imports: [CommonModule, Input, Button],
})
export class ProductCategoryFormComponent {
    cancel = output<void>();
    submit = output<void>();

    value = model<string>("");
}
